export enum BusinessConfigEnum {
    Locations,
    People,
    Availability,
    Customers,
    ActiveNumbers,
    BuyNumber,
    ForwardingInstructions
}
